import React from 'react';
import { observer } from 'mobx-react';
import AddDeviceInDbComponent from './Add-device-in-db.component';
import useAddDeviceInDb from './useAddDeviceInDb';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { download, devices, lang, state, handlers } =
        useAddDeviceInDb(onClose);

    return (
        <>
            <AddDeviceInDbComponent
                lang={lang.lang}
                imei={state.imei}
                imeiError={state.imeiError}
                type={state.type}
                typeError={state.typeError}
                password={state.password}
                passwordError={state.passwordError}
                swVer={state.swVer}
                swVerError={state.swVerError}
                bootVer={state.bootVer}
                bootVerError={state.bootVerError}
                hwVer={state.hwVer}
                hwVerError={state.hwVerError}
                serverError={devices.serverError}
                uploadError={download.uploadError}
                deviceAlreadyExistError={devices.deviceAlreadyExistError}
                loading={devices.addDeviceInDbLoading}
                onImeiChange={handlers.handleImeiChange}
                onTypeChange={handlers.handleTypeChange}
                onPasswordChange={handlers.handlePasswordChange}
                onSwVerChange={handlers.handleSwVerChange}
                onHwVerChange={handlers.handleHwVerChange}
                onBootVerChange={handlers.handleBootVerChange}
                onAddClick={handlers.handleAddClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onTemplateDownload={handlers.handleTemplateDownload}
                onDevicesUpload={handlers.handleDevicesUpload}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const AddDeviceInDbContainer = observer(Container);

export default AddDeviceInDbContainer;
